import React from 'react';
import { createStyles } from '@/contexts/theme-context';
import { ManagerTableRow } from '@/experiences/sales-portal/domain/prospects/screens/prospects/components/prospects-manager-view/manager-table-row';
import { Pressable } from 'react-native';
import { Row } from '@tanstack/react-table';

interface ManagerTablePressableRowProps<TData> {
  accessibilityLabel: string;
  index: number;
  onRowClick: (row: TData) => void;
  row: Row<TData>;
}

const ManagerTablePressableRowComponent = <TData,>({
  accessibilityLabel,
  index,
  onRowClick,
  row,
}: ManagerTablePressableRowProps<TData>) => {
  const [styles] = useStyles();

  return (
    <Pressable
      accessibilityLabel={accessibilityLabel}
      accessibilityRole="button"
      onPress={() => onRowClick(row.original)}
      style={styles.pressable}
    >
      {({ focused, hovered }) => (
        <ManagerTableRow
          highlighted={focused || hovered}
          index={index}
          row={row}
        />
      )}
    </Pressable>
  );
};

export const ManagerTablePressableRow = React.memo(
  ManagerTablePressableRowComponent,
) as typeof ManagerTablePressableRowComponent;

const useStyles = createStyles(() => ({
  pressable: {
    cursor: 'pointer',
  },
}));
